
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { VNCStandardObj } from "./vnc-standard-obj";

export enum DueDateTimeRangeType {
  LAST_HOUR = 1,
  LAST_24_HOURS,
  LAST_WEEK,
  LAST_MONTH,
  LAST_YEAR,
  CUSTOM,
  NONE
}

export function getAllDueDateTimeRangeTypes(): DueDateTimeRangeType[] {
  return [
    DueDateTimeRangeType.LAST_HOUR,
    DueDateTimeRangeType.LAST_24_HOURS,
    DueDateTimeRangeType.LAST_WEEK,
    DueDateTimeRangeType.LAST_MONTH,
    DueDateTimeRangeType.LAST_YEAR,
    DueDateTimeRangeType.CUSTOM,
    DueDateTimeRangeType.NONE
  ];
}

export function getDueDateTimeRangeType(type: DueDateTimeRangeType): VNCStandardObj {
  let slug = "";
  let title = "";
  let key = "";

  switch (type) {
    case DueDateTimeRangeType.LAST_HOUR: {
      slug = "last_hour";
      key = "TIME_LAST_HOUR";
      break;
    }

    case DueDateTimeRangeType.LAST_24_HOURS: {
      slug = "last_24_hours";
      key = "TIME_LAST_24_HOURS";
      break;
    }

    case DueDateTimeRangeType.LAST_WEEK: {
      slug = "last_week";
      key = "TIME_LAST_WEEK";
      break;
    }

    case DueDateTimeRangeType.LAST_MONTH: {
      slug = "last_month";
      key = "TIME_LAST_MONTH";
      break;
    }

    case DueDateTimeRangeType.NONE: {
      slug = "none";
      key = "NONE";
      break;
    }

    default: {
      slug = "custom";
      key = "TIME_CUSTOM";
      break;
    }
  }

  return {
    slug: slug,
    title: title,
    translation_key: key,
  };
}

export function DueDatetimeRangeTypeFromString(str: string): DueDateTimeRangeType {
  switch (str) {
    case "last_hour":
      return DueDateTimeRangeType.LAST_HOUR;
    case "last_24_hours":
      return DueDateTimeRangeType.LAST_24_HOURS;
    case "last_week":
      return DueDateTimeRangeType.LAST_WEEK;
    case "last_month":
      return DueDateTimeRangeType.LAST_MONTH;
    case "none":
      return DueDateTimeRangeType.NONE;
    default:
      return DueDateTimeRangeType.CUSTOM;
  }
}
